module.exports = __webpack_public_path__ + "img/4ตะวันตก.97f80c0e.jpg";